import { isValidZipcode, isValidNumber } from "./_validation.js";

/**
 * 入力値の取得
 * @param {string} type 物件種別 ('house' | 'land')
 * @param {Object} inputs 入力要素オブジェクト
 * @param {HTMLElement} inputs.zipcode 郵便番号入力要素
 * @param {HTMLElement} inputs.buildingArea 建物面積入力要素（戸建の場合）
 * @param {HTMLElement} inputs.landArea 土地面積入力要素
 * @param {HTMLElement} inputs.yearsOld 築年数入力要素（戸建の場合）
 * @returns {Object|null}
 */
export const getInputValues = (type, inputs) => {
    const zipcode = inputs.zipcode?.value?.trim();

    if (!isValidZipcode(zipcode)) {
        return null;
    }

    if (type === "house") {
        const buildingArea = inputs.buildingArea?.value?.trim();
        const landArea = inputs.landArea?.value?.trim();
        const yearsOld = inputs.yearsOld?.value?.trim();

        if (
            !isValidNumber(buildingArea) ||
            !isValidNumber(landArea) ||
            !isValidNumber(yearsOld)
        ) {
            return null;
        }

        return {
            estate_zip: zipcode,
            building_area: parseFloat(buildingArea),
            land_area: parseFloat(landArea),
            years_old: parseInt(yearsOld, 10),
        };
    } else if (type === "land") {
        const landArea = inputs.landArea?.value?.trim();

        if (!isValidNumber(landArea)) {
            return null;
        }

        return {
            estate_zip: zipcode,
            land_area: parseFloat(landArea),
        };
    }

    return null;
};

/**
 * 初期値があるかチェック
 * @param {string} type 物件種別
 * @param {Object} inputs 入力要素オブジェクト
 * @returns {boolean}
 */
export const hasInitialValues = (type, inputs) => {
    const zipcode = inputs.zipcode?.value?.trim();
    if (!isValidZipcode(zipcode)) return false;

    if (type === "house") {
        const buildingArea = inputs.buildingArea?.value?.trim();
        const landArea = inputs.landArea?.value?.trim();
        const yearsOld = inputs.yearsOld?.value?.trim();
        return (
            isValidNumber(buildingArea) &&
            isValidNumber(landArea) &&
            isValidNumber(yearsOld)
        );
    } else {
        const landArea = inputs.landArea?.value?.trim();
        return isValidNumber(landArea);
    }
};

/**
 * 郵便番号と土地面積の値をリアルタイムで同期する関数
 * @param {HTMLElement} otherInput 他方のタブの入力要素
 * @param {string} value 値
 */
export const syncInputValueRealtime = (otherInput, value) => {
    if (otherInput) {
        otherInput.value = value;
    }
};

/**
 * タブ切り替え時の入力値の同期
 * @param {HTMLElement} fromZipInput 元のタブの郵便番号入力要素
 * @param {HTMLElement} fromLandAreaInput 元のタブの土地面積入力要素
 * @param {HTMLElement} toZipInput 切り替え先のタブの郵便番号入力要素
 * @param {HTMLElement} toLandAreaInput 切り替え先のタブの土地面積入力要素
 */
export const syncInputValues = (
    fromZipInput,
    fromLandAreaInput,
    toZipInput,
    toLandAreaInput
) => {
    if (fromZipInput && toZipInput) {
        toZipInput.value = fromZipInput.value;
    }
    if (fromLandAreaInput && toLandAreaInput) {
        toLandAreaInput.value = fromLandAreaInput.value;
    }
};
